<template>
  <div>
    <div v-if="editMode" class="sf-level-vertical">
      <div class="sf-level">
        <remark-tags
          v-model="editableTagIds"
          :all-tags="allRemarkTags"
          :hide-header="true"
        />
      </div>
      <div class="sf-level sf-alignr">
        <a
          class="sf-font-bold sf-font-xs sf-c-primary-dark sf-a"
          @click="toggleEditMode(false)"
          >{{ I18n.t('common.form.cancel') }}</a
        >
        <a
          :class="{ 'sf-disabled': editableTagIds === tagIds }"
          class="sf-btn sf-btn-primary sf-btn-small"
          @click="handleUpdateTagsClick"
          >{{ I18n.t('common.save') }}
        </a>
      </div>
    </div>
    <div
      v-if="!editMode && (tagIds.length || showEditModeToggle)"
      class="sf-level"
    >
      <remark-tags-list :tag-ids="tagIds">
        <a
          v-if="showEditModeToggle"
          class="sf-font-bold sf-font-xs sf-c-primary-dark sf-a"
          @click="toggleEditMode(true)"
          >{{ editLabel }}</a
        >
      </remark-tags-list>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import api from '../../api/remark'
import RemarkTagsList from './remark-tags-list'
import RemarkTags from '../../../../../../shared/vue/components/new-remark/remark-tags'
import remarkTagsMixin from '../../../../../../shared/vue/components/new-remark/mixins/remark-tags-mixin'

export default {
  components: {
    RemarkTagsList,
    RemarkTags,
  },
  mixins: [remarkTagsMixin],
  props: {
    remarkId: {
      type: Number,
      required: true,
    },
    tagIds: {
      type: Array,
      required: true,
    },
    allowedActions: {
      type: Object,
      required: true,
    },
    companyId: {
      type: Number,
      default: null,
    },
  },
  emits: ['tags-updated'],
  data() {
    return {
      editMode: false,
      editableTagIds: [],
    }
  },
  computed: {
    ...mapState({
      allRemarkTags: (state) =>
        state.remarkTags ? state.remarkTags.allRemarkTags : null,
    }),
    editLabel() {
      return this.tagIds.length
        ? I18n.t('communication.cards.edit_tags')
        : I18n.t('communication.cards.add_tags')
    },

    showEditModeToggle() {
      // user must be allowed to udpate tags AND
      //    there's at least one unarchived firm-level Tag
      //      OR
      //    the remark already has some tags
      return (
        this.allowedActions.updateTags &&
        (this.anyUnarchivedTags || this.tagIds.length)
      )
    },
  },
  created() {
    this.editableTagIds = this.tagIds
  },
  methods: {
    async handleUpdateTagsClick() {
      const params = [this.remarkId, { tagIds: this.editableTagIds }]
      if (!Silverfin.currentCompanyId) {
        params.push(this.companyId)
      }

      const { remark } = await api.update(...params)

      this.editMode = false
      this.$emit('tags-updated', { remark })
    },
    toggleEditMode(value) {
      this.editMode = value
    },
  },
}
</script>
